/**
 * Celular na tela de senha do Identifier First.
 *
 * A Auth0 só devolve em `screen.data` os identificadores que a connection
 * conhece — e neste tenant o celular não é um deles, então ele atravessa do
 * `signup-id` pelo handoff de perfil (`ulp-phone`, em E.164). A ordem abaixo
 * deixa a Auth0 ganhar quando passar a devolvê-lo.
 */

/** Chave do handoff — a mesma que as Actions leem primeiro no `signup()`. */
export const PHONE_HANDOFF_KEY = 'ulp-phone'

export type PhoneSources = {
  /** `screen.data.phoneNumber` do SDK ACUL. */
  fromScreen?: string | null
  /** Handoff de perfil gravado pelo `signup-id`. */
  fromHandoff?: Record<string, string> | null
  /** `?phone=` do preview local (sem transação Auth0). */
  fromPreview?: string | null
}

export function resolveSignupPhone(sources: PhoneSources): string {
  return (
    sources.fromScreen ||
    sources.fromHandoff?.[PHONE_HANDOFF_KEY] ||
    sources.fromPreview ||
    ''
  )
}
